import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './routing.module';
import { HttpModule  } from '@angular/http';
import { DropdownModule } from 'primeng/components/dropdown/dropdown';
import { CheckboxModule } from 'primeng/components/checkbox/checkbox';
import { PanelModule } from 'primeng/components/panel/panel';
import { DataTableModule } from 'primeng/components/datatable/datatable';
import { TableModule } from 'primeng/components/table/table';
import { ScheduleModule } from 'primeng/components/schedule/schedule';
import { DataGridModule } from 'primeng/components/datagrid/datagrid';
import { PickListModule } from 'primeng/components/picklist/picklist';
import { OrderListModule } from 'primeng/components/orderlist/orderlist';
import { TreeTableModule } from 'primeng/components/treetable/treetable';
import { DataListModule } from 'primeng/components/datalist/datalist';
import { CarouselModule } from 'primeng/components/carousel/carousel';
import { TreeModule } from 'primeng/components/tree/tree';
import { ButtonModule } from 'primeng/components/button/button';
import { DialogModule } from 'primeng/components/dialog/dialog';
import { PasswordModule } from 'primeng/components/password/password';
import { InputTextModule } from 'primeng/components/inputtext/inputtext';
import { CalendarModule } from 'primeng/components/calendar/calendar';
import { LocalStorageModule } from 'angular-2-local-storage';
import { MessagesModule } from 'primeng/components/messages/messages';
import {
  AccordionModule,
  CardModule,
  ChipsModule,
  FileUploadModule,
  InputTextareaModule,
  MessageModule
} from 'primeng/primeng';
import { ConfirmDialogModule } from 'primeng/components/confirmdialog/confirmdialog';
import { GrowlModule } from 'primeng/components/growl/growl';
import { ToastModule } from 'primeng/toast';
import { ListboxModule } from 'primeng/components/listbox/listbox';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AutoCompleteModule, OrganizationChartModule, StepsModule } from 'primeng/primeng';
import { SelectButtonModule } from 'primeng/primeng';
import { MenubarModule } from 'primeng/primeng';
import { RadioButtonModule } from 'primeng/primeng';
import { SliderModule } from 'primeng/primeng';
import { TabMenuModule } from 'primeng/primeng';
import { TabViewModule } from 'primeng/primeng';
import { GMapModule } from 'primeng/primeng';
import { MultiSelectModule } from 'primeng/primeng';
import { InputSwitchModule } from 'primeng/primeng';
import { OverlayPanelModule } from 'primeng/primeng';
import { InputMaskModule } from 'primeng/components/inputmask/inputmask';
import { HttpClientServiceLang } from '../services/httpClient/httpclient.service';
import { SpinnerModule } from 'primeng/primeng';
import { ProgressBarModule } from 'primeng/primeng';
import { PaginatorModule } from 'primeng/primeng';
import { ChartModule } from 'angular2-highcharts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxLocalizedNumbers } from 'ngx-localized-numbers/localized-numbers.module';
import { TooltipModule } from 'primeng/primeng';
import { CommonModule } from '@angular/common';
import { AgmCoreModule } from '@agm/core';
import { DragulaModule } from 'ng2-dragula';
import { Ng5SliderModule } from 'ng5-slider';
import { QueryBuilderModule } from "angular2-query-builder";
import { TableauModule } from 'ngx-tableau';


// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClientServiceLang) {
  const thl =  new TranslateHttpLoader( http, '/koncentro-auth/languages/', '');
  return thl;
}

export const BASE_MODULES = [
  FormsModule,
  ReactiveFormsModule,
  HttpModule,
  AppRoutingModule,
  TooltipModule,
  DropdownModule,
  CheckboxModule,
  ChipsModule,
  PanelModule,
  DataTableModule,
  TableModule,
  ScheduleModule,
  DataGridModule,
  PickListModule,
  OrderListModule,
  TreeTableModule,
  DataListModule,
  CarouselModule,
  TreeModule,
  ButtonModule,
  DialogModule,
  InputTextModule,
  FileUploadModule,
  PasswordModule,
  CalendarModule,
  MessagesModule,
  MessageModule,
  ConfirmDialogModule,
  GrowlModule,
  ToastModule,
  OrganizationChartModule,
  ListboxModule,
  StepsModule,
  SelectButtonModule,
  MenubarModule,
  RadioButtonModule,
  SliderModule,
  TabMenuModule,
  TabViewModule,
  GMapModule,
  MultiSelectModule,
  InputSwitchModule,
  OverlayPanelModule,
  InputMaskModule,
  SpinnerModule,
  ProgressBarModule,
  CommonModule,
  PaginatorModule,
  AutoCompleteModule,
  AccordionModule,
  InputTextareaModule,
  CardModule
];

export const MODULES = [
  ...BASE_MODULES,
  BrowserModule,
  BrowserAnimationsModule,
  DragulaModule.forRoot(),
  Ng5SliderModule,
  QueryBuilderModule,

  LocalStorageModule.withConfig({
    prefix: 'koncentro',
    storageType: 'localStorage'
  }),

  // ChartModule.forRoot(
  //   require('highcharts'),
  //   require('highcharts/highcharts-more'),
  //   require('highcharts/modules/sankey'),
  //   require('highcharts/modules/heatmap'),
  //   require('highcharts/modules/exporting')
  // ),

  NgxLocalizedNumbers.forRoot(),

  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClientServiceLang]
    }
  }),

  AgmCoreModule.forRoot({
    // please get your own API key here:
    // https://developers.google.com/maps/documentation/javascript/get-api-key?hl=en
    apiKey: 'AIzaSyAvcDy5ZYc2ujCS6TTtI3RYX5QmuoV8Ffw'
  }),

  TableauModule
];



// WEBPACK FOOTER //
// ./src/app/modules/index.ts